import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveFundingStatus } from '@/lib/domain';

export interface FundingStatusPillProps {
  status: string | null | undefined;
  campaignId?: string;
}

export const FundingStatusPill = ({ status, campaignId }: FundingStatusPillProps) => {
  const { t } = useTranslation('funding');
  const meta = resolveFundingStatus(status, campaignId ? { campaignId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="funding-status-pill"
    />
  );
};
